<template>
  <div class="s-overlap-strips__strip">
    <div class="s-overlap-strips__conts">
      <div class="s-overlap-strips__row">
        <div class="s-wizard__results__txt">
          <h2 class="s-wizard__results__txt__header">
            {{ data.title }}
          </h2>
          <div class="s-wizard__results__txt__wrp">
            <div
              class="s-wizard__results__txt__boxes s-wizard__results__txt__boxes--space-between">
              <div class="s-wizard__results__txt__box">
                <div class="header">
                  <div class="title">
                    <h3>{{ dictionary.resultsSaveAmountLabel }}</h3>
                  </div>
                </div>
                <div class="result">
                  <span class="price">{{ data.amount }}</span>
                  <span class="price-suffix">
                    {{ dictionary.resultsSaveAmountSuffix }}
                  </span>
                </div>
              </div>
              <div class="s-wizard__results__txt__box">
                <div class="header">
                  <div class="title">
                    <h3>{{ dictionary.resultsAverageReturnLabel }}</h3>
                    <span>{{ dictionary.resultsAverageReturnSubLabel }}</span>
                  </div>
                  <div class="subtitle">
                    {{ dictionary.resultsAverageReturnSliderLabel }}
                  </div>
                </div>
                <div class="result" style="height: 60px">
                  <VueSlider
                    v-if="minValue >= 0 && maxValue > 0"
                    v-model="selectedValue"
                    v-bind="sliderOptions"
                    :min="minValue"
                    :max="maxValue"
                    :marks="mark"
                    :interval="interval" />
                </div>
              </div>
              <div
                class="s-wizard__results__txt__box s-wizard__results__txt__box--graph">
                <div class="header">
                  <div class="title">
                    <h3>{{ dictionary.resultsMoneyLabel }}</h3>
                  </div>
                  <div class="subtitle">
                    <span>{{ dictionary.resultsGoalLabel }}</span>
                    <span class="amount">{{ data.goalAmount }}</span>
                  </div>
                </div>
                <div class="result">
                  <img
                    v-if="data.goalImageGraph"
                    :src="data.goalImageGraph.url"
                    :alt="data.goalImageGraph.alt"
                    style="border-right: 1px dotted white" />
                  <span class="duration">{{ data.goalDuration }}</span>
                </div>
              </div>
            </div>
          </div>

          <!--disclaimer-->
          <div v-if="data.disclaimerText" class="b-disclaimer">
            <div class="b-disclaimer__cont">
              <div class="b-disclaimer__item">
                <div class="b-disclaimer__label">
                  {{ data.disclaimerTitle }}
                </div>
                <div
                  class="b-disclaimer__txt"
                  v-html="data.disclaimerText"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlider from 'vue-slider-component'

export default {
  components: {
    VueSlider,
  },
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      interval: 1,
      rate: 1,

      mark: (val) => ({
        label: `${val}%`,
        labelStyle: {
          fontSize: '24px',
          lineHeight: '30px',
          fontWeight: 400,
        },
      }),

      sliderOptions: {
        lazy: true,
        duration: null,
        height: 7,
        contained: true,
      },

      selectedValue: 4,

      minValue: 2,
      maxValue: 6,
    }
  },
  mounted() {
    this.setSliderValues()
  },
  methods: {
    setSliderValues() {
      this.minValue = this.data.sliderRange.min
      this.maxValue = this.data.sliderRange.max
      this.selectedValue = this.minValue
    },
  },
}
</script>
